import SEOHead from '@/components/base/SEOHead';
import PageJsonLd from '@/components/base/PageJsonLd';
import Layout from '@/components/feature/Layout';
import CTASection from '@/components/feature/CTASection';
import { Link } from 'react-router-dom';

interface PageShellProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  h1: string;
  subtitle?: string;
  children: React.ReactNode;
  showCTA?: boolean;
  ctaTitle?: string;
  relatedLinks?: { label: string; path: string }[];
}

export default function PageShell({
  title,
  description,
  keywords,
  canonical,
  h1,
  subtitle,
  children,
  showCTA = true,
  ctaTitle = 'プロジェクトの整理を、AIに任せてみませんか？',
  relatedLinks,
}: PageShellProps) {
  return (
    <Layout>
      <SEOHead title={title} description={description} keywords={keywords} canonical={canonical} />
      <PageJsonLd canonical={canonical} name={h1} description={description} />
      <article className="py-12 md:py-16">
        <div className="max-w-[960px] mx-auto px-4 md:px-6">
          <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4">{h1}</h1>
          {subtitle && <p className="text-base text-foreground-600 mb-10 leading-relaxed">{subtitle}</p>}
          <div className="prose prose-sm md:prose-base max-w-none text-foreground-700">
            {children}
          </div>
          {relatedLinks && relatedLinks.length > 0 && (
            <div className="mt-12 p-6 bg-background-100 rounded-lg border border-background-200/70">
              <h2 className="text-base font-bold text-foreground-900 mb-3">関連ページ</h2>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {relatedLinks.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-sm text-primary-600 hover:text-primary-700 inline-flex items-center gap-1">
                      <i className="ri-arrow-right-s-line"></i>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </article>
      {showCTA && <CTASection title={ctaTitle} />}
    </Layout>
  );
}